export default {
  default: () => import("/home/app/agent-snap/layouts/Default.vue").then(m => m.default || m),
  "default-auth": () => import("/home/app/agent-snap/layouts/DefaultAuth.vue").then(m => m.default || m),
  "default-full-screen": () => import("/home/app/agent-snap/layouts/DefaultFullScreen.vue").then(m => m.default || m),
  guest: () => import("/home/app/agent-snap/layouts/guest.vue").then(m => m.default || m),
  "default-sign-up-steps": () => import("/home/app/base/layouts/DefaultSignUpSteps.vue").then(m => m.default || m)
}